module.exports = __webpack_public_path__ + "static/media/icon3.3d000cd0.svg";